import { Components, Theme } from '@mui/material/styles'

export const surfaceCustomization: Components<Theme> = {
}
